import { Component, OnInit } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute } from '@angular/router'
import moment from 'moment'
import { forkJoin } from 'rxjs/internal/observable/forkJoin'
import { ClientDto } from 'src/app/models/client/client-dto'
import { Filter } from 'src/app/models/power-bi/filter'
import { ReddiRoundGraphTableDto } from 'src/app/models/reddi/redd-round-graph-dto'
import { ReddiConfigurationDto } from 'src/app/models/reddi/reddi-configuration-dto'
import { ReddiReportRoundTableDto } from 'src/app/models/reddi/reddi-report-round-dto'
import { ReddiGraphTableColumnDefinition } from 'src/app/models/table-defs/reddi-report-graph-table-def'
import { TableColumnDefinition } from 'src/app/models/table/table-column-definition'
import { TableReddiResponseIconColumnDto } from 'src/app/models/table/table-reddi-response-icon-column-dto'
import { BannerService } from 'src/app/services/banner/banner.service'
import { ClientService } from 'src/app/services/client/client.service'
import { CommonService } from 'src/app/services/common/common.service'
import { ConfigService } from 'src/app/services/config/config.service'
import { PdfService } from 'src/app/services/pdf/pdf.service'
import { PreviousRouteService } from 'src/app/services/previous-route/previous-route.service'
import {
  CreateReddiRoundTableDto,
  ListeningCondition,
  Result,
} from 'src/app/services/reddi/reddi-utils'
import { ReddiService } from 'src/app/services/reddi/reddi.service'
import { SpinnerService } from 'src/app/services/spinner/spinner.service'

export type ReddiResponseType = 'detection' | 'imitation' | 'none'

@Component({
  selector: 'app-reddi-external-report',
  templateUrl: './reddi-external-report.component.html',
  styleUrls: ['./reddi-external-report.component.scss'],
  standalone: false,
})
export class ReddiExternalReportComponent implements OnInit {
  _todayDate: Date = new Date()
  _fallbackUrl: string = '/dashboard'
  _client: ClientDto
  _iteration: ReddiReportRoundTableDto[]
  _configuration: ReddiConfigurationDto
  _clientId: string
  _lastAssessmentDateAgo: string
  _lastAssessmentDateUnavailable: boolean = false
  _lastAssessmentDate: string
  _age: string
  _dob: string
  _score: string = '0'
  _clientName: string
  _title: string
  _role: string
  _name: string
  _reddiFilters: Filter[]
  selectedDropdownValues: boolean[] = [] // Declare the property here
  formattedDate: string
  _fromDate: Date
  _toDate: Date
  _fromDisplayDate: string
  _toDisplayDate: string
  _comment: string
  _sentence: number
  _listiningConditionText: string
  noDataText: string = 'Assessments not available for this client'

  _dateFormat: string = 'Do MMMM, YYYY'
  _dateFormat1: string = 'DD-MMM-YYYY'
  _tableColumnDefinitions: TableColumnDefinition[] =
    ReddiGraphTableColumnDefinition
  _tableData: MatTableDataSource<ReddiRoundGraphTableDto> =
    new MatTableDataSource<ReddiRoundGraphTableDto>()
  _tableColumnsToDisplay: string[] = []
  allColumns: string[] = [
    'age',
    'presentationDate',
    'l_m',
    'l_or',
    'l_oo',
    'l_ah',
    'l_ee',
    'l_sh',
    'l_s',
    'empty_l',
    'r_m',
    'r_or',
    'r_oo',
    'r_ah',
    'r_ee',
    'r_sh',
    'r_s',
    'empty_r',
    'e_m',
    'e_or',
    'e_oo',
    'e_ah',
    'e_ee',
    'e_sh',
    'e_s',
  ]
  exceptSound2: string[] = [
    'age',
    'presentationDate',
    'l_m',
    'l_or',
    'l_oo',
    'l_ah',
    'l_ee',
    'l_sh',
    'l_s',
    'empty_l',
    'r_m',
    'r_or',
    'r_oo',
    'r_ah',
    'r_ee',
    'r_sh',
    'r_s',
    'empty_r',
    'e_m',
    'e_or',
    'e_oo',
    'e_ah',
    'e_ee',
    'e_sh',
    'e_s',
  ]
  _totalReviews = 0
  _hasAccess: any = {
    slatHasAccess: false,
    flipHasAccess: false,
    reddiHasAccess: false,
  }
  protected logoFolderPath: string =
    this.config.getSettings('spa').imageFolder + '/reddi-logo/'
  protected reddiLogoPath: string =
    this.logoFolderPath + 'Reddi-Logo-168x62.png'
  protected path: string

  /**
   *
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private bannerService: BannerService,
    private clientService: ClientService,
    private reddiService: ReddiService,
    private prevRoute: PreviousRouteService,
    public spinnerService: SpinnerService,
    private pdfService: PdfService,
    private config: ConfigService,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.path = this.reddiLogoPath
    this.getData()
  }

  getData() {
    this.spinnerService.show()
    this.activatedRoute.queryParams.subscribe((params) => {
      this.selectedDropdownValues = [
        params['dropdown1'],
        params['dropdown2'],
        params['dropdown3'],
      ]
      this._name = params['clinicianName']
      this._role = params['title']
      this._fromDate = params['fromDate']
      this._toDate = params['toDate']
      this._fromDisplayDate = moment(params['fromDate']).format(
        this._dateFormat,
      )
      this._toDisplayDate = moment(params['toDate']).format(this._dateFormat)
      this._comment = params['comment']
      this._sentence = params['dropdown4']
    })
    this._listiningConditionText = this.showLisiningConsiditons()
    this._clientId = this.activatedRoute.snapshot.paramMap.get('clientId')
    if (!this.commonService.isValidUUID(this._clientId)) {
      this.bannerService.showBanner(`Invalid client requested.`, 'error', 3000)
      this.prevRoute.goToPreviousUrl(this._fallbackUrl)
    }

    this._reddiFilters = [
      {
        attribute: 'Client/contactid',
        operation: 'eq',
        value: this._clientId,
      },
    ]
    var fDate = new Date(moment(this._fromDate).format('YYYY-MM-DD'))
    var tDate = new Date(moment(this._toDate).format('YYYY-MM-DD'))

    var everyDay = this.selectedDropdownValues[0] == true ? 866080000 : 0
    var left = this.selectedDropdownValues[1] == true ? 866080001 : 0
    var right = this.selectedDropdownValues[2] == true ? 866080002 : 0
    let requests = {
      clientDetails: this.clientService.Details(this._clientId),
      iteration: this.reddiService.getReportReddiRounds(
        this._clientId,
        fDate,
        tDate,
        everyDay,
        left,
        right,
      ),
      configuration: this.reddiService.getConfiguration(),
    }

    forkJoin(requests).subscribe({
      next: ({ clientDetails, iteration, configuration }) => {
        this._configuration = configuration
        this._iteration = iteration
        this._tableData = new MatTableDataSource<ReddiRoundGraphTableDto>(
          this.processRounds(iteration),
        )
        this._tableColumnsToDisplay = this.getTableColumns(
          !this._configuration.ignoreSound2,
        )
        this._client = clientDetails
        this._clientName = this._client.preferredFullName
        this._age = this._client.age
        this._dob = moment(this._client.dateOfBirth).format(this._dateFormat)
        this._title = this._client.preferredFullName
        this.checkToolsAccess()
        this.retriveIndicators(clientDetails)
        this.spinnerService.hide()
      },
      error: () => {
        this.bannerService.showBanner(
          `Unable to retrieve assessment details.`,
          'error',
          3000,
        )
        this.prevRoute.goToPreviousUrl(this._fallbackUrl)
      },
    })
  }

  getDefaultListiningCondition(
    imitation: string,
  ): TableReddiResponseIconColumnDto {
    return { type: 'none', outcome: 'neutral', tooltip: imitation, color: '' }
  }

  getListiningCondition(
    condition: boolean,
    soundResult: Result,
    imitation: string,
    soundScore?: number,
  ): TableReddiResponseIconColumnDto {
    return condition == true
      ? CreateReddiRoundTableDto(soundResult, imitation, soundScore)
      : this.getDefaultListiningCondition(imitation)
  }

  processRounds(reddi: ReddiReportRoundTableDto[]): ReddiRoundGraphTableDto[] {
    const tableRounds: ReddiRoundGraphTableDto[] = []
    let round: ReddiReportRoundTableDto
    for (let r = 0; r < reddi.length; r++) {
      round = reddi[r]
      tableRounds.push({
        orderCounter: round.orderCounter,
        age: round.age,
        listening: ListeningCondition[round.listeningCondition],
        presentationDate: moment(round.presentationDate).format(
          this._dateFormat1,
        ),
        l_m: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound1Result,
          round.sound1Imitation,
          round.sound1Score,
        ),
        l_or: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound2Result,
          round.sound2Imitation,
          round.sound2Score,
        ),
        l_oo: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound3Result,
          round.sound3Imitation,
          round.sound3Score,
        ),
        l_ah: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound4Result,
          round.sound4Imitation,
          round.sound4Score,
        ),
        l_ee: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound5Result,
          round.sound5Imitation,
          round.sound5Score,
        ),
        l_sh: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound6Result,
          round.sound6Imitation,
          round.sound6Score,
        ),
        l_s: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Left,
          round.sound7Result,
          round.sound7Imitation,
          round.sound7Score,
        ),
        empty_l: '',
        r_m: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound1Result,
          round.sound1Imitation,
          round.sound1Score,
        ),
        r_or: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound2Result,
          round.sound2Imitation,
          round.sound2Score,
        ),
        r_oo: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound3Result,
          round.sound3Imitation,
          round.sound3Score,
        ),
        r_ah: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound4Result,
          round.sound4Imitation,
          round.sound4Score,
        ),
        r_ee: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound5Result,
          round.sound5Imitation,
          round.sound5Score,
        ),
        r_sh: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound6Result,
          round.sound6Imitation,
          round.sound6Score,
        ),
        r_s: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Right,
          round.sound7Result,
          round.sound7Imitation,
          round.sound7Score,
        ),
        empty_r: '',
        e_m: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound1Result,
          round.sound1Imitation,
          round.sound1Score,
        ),
        e_or: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound2Result,
          round.sound2Imitation,
          round.sound2Score,
        ),
        e_oo: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound3Result,
          round.sound3Imitation,
          round.sound3Score,
        ),
        e_ah: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound4Result,
          round.sound4Imitation,
          round.sound4Score,
        ),
        e_ee: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound5Result,
          round.sound5Imitation,
          round.sound5Score,
        ),
        e_sh: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound6Result,
          round.sound6Imitation,
          round.sound6Score,
        ),
        e_s: this.getListiningCondition(
          round.listeningCondition == ListeningCondition.Everyday,
          round.sound7Result,
          round.sound7Imitation,
          round.sound7Score,
        ),
      })
    }
    return tableRounds
  }

  getTableColumns(sound2Enabled: boolean) {
    return sound2Enabled ? this.allColumns : this.exceptSound2
  }

  generateReportPDF() {
    this.formattedDate = moment(this._todayDate).format(this._dateFormat1)
    var reportName = this._title + ' ' + this.formattedDate + ' REDDI-Report'
    this.pdfService.generateReportPdfIMAGE(reportName)
  }

  getText(type: string): string {
    switch (type) {
      case 'detection':
        return '*'
      case 'imitation':
        return '-'
      default:
        return ''
    }
  }

  showLisiningConsiditons(): string {
    if (
      this.selectedDropdownValues[0] == true &&
      this.selectedDropdownValues[1] == true &&
      this.selectedDropdownValues[2] == false
    ) {
      return "The listening condition of 'Everyday' and 'Left' will display."
    } else if (
      this.selectedDropdownValues[0] == true &&
      this.selectedDropdownValues[1] == false &&
      this.selectedDropdownValues[2] == true
    ) {
      return "The listening condition of 'Everyday' and 'Right' will display."
    } else if (
      this.selectedDropdownValues[0] == false &&
      this.selectedDropdownValues[1] == true &&
      this.selectedDropdownValues[2] == true
    ) {
      return "The listening condition of 'Left' and 'Right' will display."
    } else if (
      this.selectedDropdownValues[0] == true &&
      this.selectedDropdownValues[1] == false &&
      this.selectedDropdownValues[2] == false
    ) {
      return "The listening condition of 'Everyday' will display."
    } else if (
      this.selectedDropdownValues[0] == false &&
      this.selectedDropdownValues[1] == true &&
      this.selectedDropdownValues[2] == false
    ) {
      return "The listening condition of 'Left' will display."
    } else if (
      this.selectedDropdownValues[0] == false &&
      this.selectedDropdownValues[1] == false &&
      this.selectedDropdownValues[2] == true
    ) {
      return "The listening condition of 'Right' will display."
    }
    return ''
  }

  checkToolsAccess() {
    this._hasAccess.flipHasAccess = this.commonService.clientHasAccessToFlip(
      this._client,
    )
    this._hasAccess.reddiHasAccess = this.commonService.clientHasAccessToReddi(
      this._client,
    )
    this._hasAccess.slatHasAccess = this.commonService.clientHasAccessToSlat(
      this._client,
    )
  }

  retriveIndicators(client: ClientDto) {
    this._totalReviews = this.commonService.returnReviewIndicator(client)
  }

  previousRoute() {
    const prevUrl = this.prevRoute.getPreviousUrl()
    if (prevUrl) {
      this.prevRoute.goToPreviousUrl(prevUrl)
    }
  }
}
